export type SearchParamsType = {
  filter: {
    status: number;
    searchText: string;
  };
  sortOrder: string;
  sortField: string;
  pageNumber: number;
  pageSize: number;
};

export type MasterTableDataType = {
  companyId: number;
  companyName: string;
  companyContact: string;
  companyAddress: string;
  companyLocation: string;
  companyPhone: string;
  companyMobile: string;
  companyWebsite: string;
  companyEmail: string;
  companyFax: string;
  companyStatus: number;
  countryName: string;
  stateId: number;
  countryId:number;
  stateName:string
};



export type MasterDataType = {
  companyId: number;
  companyName: string;
  companyContact: string;
  companyAddress: string;
  countryId: number;
  companyEmail: string;
  companyFax: string;
  companyMobile: string;
  companyPhone: string;
  stateId: number;
  companyWebsite: string|null;
  companyLocation: string;
  companyStatus: number;
  clinicId: number;
  createdById: number;
  createdDate: string;
};

export type SaveResponseType = {};

export type MasterFormDataType = {
  companyName: string;
  contactName: string;
  address: string;
  website: string;
  fax: string;
  location: string;
  mobile: string;
  landphone: string;
  email: string;
  country: any;
  state: any;
  status:number
};

export const initialFormData: MasterFormDataType = {
  companyName:"",
  contactName:"",
  address:"",
  website:"",
  fax:"",
  location:"",
  mobile:"",
  landphone:"",
  email:"",
  country:null,
  state:null,
  status:1
};
